import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { generatePath, Link } from 'react-router-dom';
import { ExternalLink } from '../../../icons/external-link';
import { STRING_KEYS } from '../../../language/keys';
import { ROUTES } from '../../../consts';
import { ROUTE_VIEW_MODE } from '../../../consts/enums';
import { talentInformationStyle } from './style';

type TalentInformationProps = {
  updatedAt: string,
  version: string,
  talentId: string,
  canEditTalent: boolean,
};

const MatchTalentInformation = ({
  updatedAt,
  version,
  talentId,
  canEditTalent,
}: TalentInformationProps): JSX.Element => {
  const { t: translate } = useTranslation();

  const updatedAtInfo = updatedAt && new Date(updatedAt)
    .toLocaleDateString('en-GB').replaceAll('/', '.');

  return (
    <Box style={ talentInformationStyle.container }>
      <Box style={ talentInformationStyle.talentInformation.style }>
        <Typography
          style={ talentInformationStyle.title.style }
          color="text.primary"
        >
          {translate(STRING_KEYS.TALENT_INFO)}
        </Typography>
        {canEditTalent && (
          <Link
            to={ generatePath(ROUTES.TALENT_VIEW, { talentId, viewMode: ROUTE_VIEW_MODE.EDIT }) }
            target="_blank"
            style={ talentInformationStyle.editTalentInformation.style }
          >
            <ExternalLink color="primary" />
            <Typography
              color="primary.main"
              style={ talentInformationStyle.editTalentText }
            >
              {translate(STRING_KEYS.EDIT_TALENT_INFO)}
            </Typography>
          </Link>
        )}
      </Box>
      <Box>
        <Typography variant="caption" style={ talentInformationStyle.subTitle.style }>
          {version && `Version ${version}`}
          {updatedAtInfo && `, Last updated ${updatedAtInfo}`}
        </Typography>
      </Box>
    </Box>
  );
};

export default React.memo(MatchTalentInformation);
